<template>
    <div>
        <el-card class="allot_card">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;">补货记录</span>
            </div>
            <div>
                <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                style="width: 100%">
                <el-table-column
                    prop="id"
                    header-align="center"
                    min-width="95"
                    label="ID">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    header-align="center"
                    min-width="180"
                    label="补货时间">
                </el-table-column>
                <el-table-column
                    prop="nickName"
                    header-align="center"
                    min-width="120"
                    label="补货人">
                </el-table-column>
                <el-table-column
                    prop="user_name"
                    header-align="center"
                    min-width="165"
                    label="补货人电话">
                </el-table-column>
                <el-table-column
                    prop="supplementNum"
                    header-align="center"
                    min-width="105"
                    label="补货数量">
                </el-table-column>
                <el-table-column
                    prop="surplusNum"
                    header-align="center"
                    min-width="105"
                    label="剩余数量">
                </el-table-column>
                </el-table>
            </div>
            <div class="table_pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      props: ['deviceCode'],
      data () {
        return {
          deviceData: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          multipleSelection: '',
          table_loading: false
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryDeviceList(this.pageNo, this.pageSize, '')
      },
      methods: {
        boxClose (tType) {
          this.$emit('boxClose', tType)
        },
        queryDeviceList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            deviceCode: _this.deviceCode
          }
          this.table_loading = true
          $axios.get('/app/supplementRecord', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    id: itemData.id,
                    createTime: itemData.createTime,
                    nickName: itemData.nickName,
                    user_name: itemData.user_name,
                    supplementNum: itemData.supplementNum,
                    surplusNum: itemData.surplusNum
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        }
      }
    }
</script>
<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 85%;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/deviceMgr/seePagerRecord.vue